<template>
  <div class="sub_content col-12 mt-2">
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit);" @reset="resetForm">
        <div class="row">
          <DataListWithValidation
            rules="required"
            type="text"
            label="회사명"
            name="form.company1.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.company1.name"
            :options="companyOption1"
            @dataChanged="dataChanged1"
            description=""
            placeholder="회사를 입력해주세요."
          />

          <SelectWithValidation
            rules="required"
            type="text"
            label="지점명"
            name="form.company2.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.company2.seq"
            :options="companyOption2"
            @dataChanged="dataChanged2"
            description=""
            placeholder="지점를 입력해주세요."
          />
        </div>

        <div class="row">
          <DataListWithValidation
            rules=""
            type="text"
            label="차량번호"
            name="form.user.tel"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.car.num"
            :options="carNumberOptions"
            @dataChanged="carNumberOptionsChange"
            description=""
            placeholder="차량번호를 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="차량명"
            title="차량명"
            name="form.car.cname"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.car.cname"
            description=""
            placeholder="차량명를 입력해주세요."
            disabled="disabled"
          />
        </div>
        <div class="row">
          <DataListWithValidation
            rules=""
            type="text"
            label="운전자"
            name="form.user.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.user.name"
            :options="userOptions"
            @dataChanged="userOptionsChange"
            description=""
            placeholder="운전자를 선택해주세요."
          />
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="운전자 연락처"
            title="운전자 연락처"
            name="form.user.tel"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.user.tel"
            description=""
            placeholder="운전자의 연락처를 입력해주세요."
            disabled="disabled"
          />
        </div>
        <div class="row">
          <InputWithValidation
            rules="required|min:1"
            type="text"
            label="CAN TYPE"
            title="CAN TYPE"
            name="form.idx"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.idx"
            description=""
            placeholder="CAN TYPE을 입력해주세요."
          />
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="단말기ID"
            title="단말기ID"
            name="form.id"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.id"
            description=""
            placeholder="단말기ID를 입력해주세요."
          />
          <SelectWithValidation
            rules="required"
            label="타입"
            name="form.gpstype"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.gpstype"
            :options="gpsTypeOptions"
            @dataChanged="gpsTypeChange"
            description=""
          />
        </div>
        <div class="row">
          <SelectWithValidation
            rules="required"
            label="DISPLAY"
            name="form.display"
            size="sm"
            class="col-4 d-inline-block"
            v-model="form.display"
            :options="displayOptions"
            @dataChanged="displayChange"
            description=""
          />
        </div>
        <hr/>
        <div class="float-right">
          <b-button type="reset" size="sm" variant="danger" class="mr-2">다시쓰기</b-button>
          <b-button type="submit" size="sm" variant="primary" class="mr-2">저장</b-button>
          <b-button type="button" size="sm" variant="dark" v-on:click="cancel">취소</b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationObserver } from 'vee-validate'
import InputWithValidation from '@/components/common/validations/inputbox'
import SelectWithValidation from '@/components/common/validations/selectbox'
import DataListWithValidation from '@/components/common/validations/datalist'
import { phoneNumber } from '@/mixin/phoneNumber'
import ax from '@/api/term'
import { mCompanys, sCompanys } from '@/api/company'
import { carNumberByCompany } from '@/api/car'
import { usersByCompany } from '@/api/user'

export default {
  name: 'TermView',
  components: {
    ValidationObserver,
    InputWithValidation,
    SelectWithValidation,
    DataListWithValidation
  },
  mixins: [phoneNumber],
  data () {
    return {
      companyOption1: [{ value: '', text: '선택' }],
      companyOption2: [{ value: '', text: '선택' }],
      carNumberOptions: [{ value: '', text: '선택', cname: '' }],
      userOptions: [{ value: '', text: '선택', tel: '' }],
      gpsTypeOptions: [
        { value: '', text: '선택' },
        { value: 'amon', text: 'AMON' },
        { value: 'gmon', text: 'GMON' },
        { value: 'emon', text: 'EMON' },
        { value: 'kmon', text: 'KMON' },
      ],
      displayOptions: [
        { value: 'N', text: '미사용' },
        { value: 'Y', text: '사용' },
      ],
      form_: {
        idx: '',
        id: '',
        cseq: null,
        mseq: null,
        useq: null,
        gpstype: 'amon',
        display: 'N',
        company1: { seq: null, name: '', sname: '' },
        company2: { seq: null, name: '', sname: '' },
        car: {
          num: '',
          custom: '',
          brand: '',
          model: '',
          smodel: '',
          grade: '',
          sgrade: '',
          vin: ''
        },
        user: {
          seq: null,
          tel: '',
          name: ''
        }
      },
      form: {}
    }
  },
  watch: {
    'form.user.tel': function () {
      this.form.user.tel = this.phoneNumberMask(this.form.user.tel)
    }
  },
  created () {
    this.form = _.cloneDeep(this.form_)
  },
  mounted () {
    mCompanys(response => {
      this.companyOption1 = response
    })
    if (this.$route.params.seq) {
      ax.get(this.$route.params.seq, response => {
        this.form = response
      })
    }
  },
  methods: {
    onSubmit () {
      ax.save(this.$route.params.seq || null, this.form, (code, msg) => {
        this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: msg
        })
        if (code === 200) {
          this.$router.push({ path: '/term', query: this.$route.query })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    cancel () {
      this.$router.push({ path: '/term', query: this.$route.query })
    },
    dataChanged1 (v) {
      // console.log('dataChanged1', v)
      if (v.value !== '') {
        sCompanys(v.text, response => {
          this.companyOption2 = [{ value: '', text: '선택' }, ...response]
        })
      } else {
        this.companyOption2 = [{ value: '', text: '선택' }]
      }
    },
    dataChanged2 (v) {
      // console.log('dataChanged2', v)
      this.form.csseq = v
      if (v) {
        // 차량번호
        carNumberByCompany(v, response => {
          this.carNumberOptions = [{ value: '', text: '선택', cname: '' }, ...response]
        })
        // 운전자
        usersByCompany(v, response => {
          this.userOptions = [{ value: '', text: '선택', tel: '' }, ...response]
        })
      }
    },
    gpsTypeChange (v) {
      this.form.gpstype = v
    },
    displayChange (v) {
      this.form.display = v
    },
    carNumberOptionsChange (v) {
      // console.log('carNumberOptionsChange', v)
      if (v.value !== '') {
        let selected = _.find(this.carNumberOptions, ['value', v.value])
        // console.log(this.carNumberOptions)
        // console.log(selected)
        this.form.cseq = selected.value
        this.form.car.cname = selected.cname
      }
    },
    userOptionsChange (v) {
      // console.log('userOptionsChange', v)
      if (v.value !== '') {
        let selected = _.find(this.userOptions, ['value', v.value])
        this.form.useq = selected.value
        this.form.user.tel = selected.tel
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.sub_content {
}


</style>
